export default __webpack_public_path__ + "static/media/servicies_mobile.bg.d7ad5a43.png";